import classnames from 'classnames';
import React, { forwardRef } from 'react';
import Highlighter from 'react-highlight-words';
import styles from "./DropdownOption.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DropdownOption = /*#__PURE__*/forwardRef(({
  onClick,
  onFocus,
  active,
  hover,
  disabled,
  children,
  label,
  small,
  'data-index': dataIndex,
  visibleCSSHover = true,
  highlightString,
  childOfCategory,
  className,
  ...liProps
}, ref) => {
  const classes = classnames([styles.dropdownOption, className, {
    [styles.active]: active,
    [styles.hover]: hover,
    [styles.visibleCSSHover]: visibleCSSHover,
    [styles.small]: small,
    [styles.disabled]: disabled,
    [styles.childOfCategory]: childOfCategory
  }]);
  return /*#__PURE__*/_jsx("li", {
    ...liProps,
    onClick: onClick,
    onFocus: onFocus,
    role: "option",
    "aria-selected": active,
    className: classes,
    "data-index": dataIndex,
    "aria-disabled": disabled,
    ref: ref,
    children: /*#__PURE__*/_jsxs("span", {
      className: styles.contentContainer,
      children: [children, !children && /*#__PURE__*/_jsx(Highlighter, {
        highlightClassName: styles.highlighted,
        searchWords: highlightString ? [highlightString] : [],
        autoEscape: true,
        textToHighlight: label
      })]
    })
  });
});